angular.module('autoremind.reports.todo')
    .directive('modalConfigDialog', function () {
    return {
        restrict: 'E',
        templateUrl: 'app/reports/todo/config.modal.html',
        controller: ['$scope', '$rootScope', 'todoService', 'dialogs', function ($scope, $rootScope, todoService, dialogs) {
                $scope.dialogHeader = 'To-Do List Settings';
                $scope.dirty = false;
                $scope.todoOptionsData = angular.copy(todoService.getTodoSettings());
                $scope.hasOptionsChanged = function () {
                    for (var i = 0; i < $scope.todoOptionsData.length; i++) {
                        var option = $scope.todoOptionsData[i];
                        for (var j = 0; j < todoService.todoOptions.length; j++) {
                            var originalOption = todoService.todoOptions[j];
                            if (option.optionKey === originalOption.optionKey
                                && option.optionType === originalOption.optionType
                                && option.optionState !== originalOption.optionState) {
                                $scope.dirty = true;
                                return true;
                            }
                        }
                    }
                    $scope.dirty = false;
                    return false;
                };
                $scope.closeDialog = function () {
                    if (!$scope.hasOptionsChanged()) {
                        $scope.cancel();
                        return;
                    }
                    /*
                     * confirm dialog, if selected options > 0,
                     * after confirm remove selected options and close all dialogs.
                    */
                    var dlg = dialogs.confirm('Confirm', 'You have unsaved data that will be lost. Are you sure you want to discard the changes?', { windowClass: 'confirmDialog' });
                    dlg.result.then(function (btn) {
                        $scope.cancel();
                    }, function (btn) {
                        console.log('Pressed no');
                    });
                };
                $scope.changeOption = function (option) {
                    $scope.hasOptionsChanged();
                    if (option.optionState) {
                        todoService.tmpOptions.push(option);
                    }
                    else {
                        for (var i in todoService.tmpOptions) {
                            if (todoService.tmpOptions[i].optionKey === option.optionKey && todoService.tmpOptions[i].optionType === option.optionType) {
                                todoService.tmpOptions.splice(i, 1);
                                //delete todoService.tmpOptions[i];
                                return;
                            }
                        }
                    }
                };
                $scope.saveSettings = function () {
                    todoService.saveSettings($scope.todoOptionsData)
                        .then(function (response) {
                        $scope.success();
                    });
                };
                $rootScope.$on('event:auth-logout', function () {
                    $scope.cancel();
                });
            }]
    };
});
//# sourceMappingURL=todo.modal.directive.js.map